import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

const INTERESTS = ["Escapadas", "Gastronomía", "Tecnología", "Entretenimiento", "Moda", "Bienestar", "Protagonistas", "Diseño y Arquitectura", "Autos", "Profesión"];

export default function Newsletter({ variant = "section" }) {
  const [form, setForm] = useState({ first_name: "", last_name: "", email: "", interests: [] });
  const [loading, setLoading] = useState(false);

  const toggleInterest = (i) =>
    setForm((f) => ({ ...f, interests: f.interests.includes(i) ? f.interests.filter((x) => x !== i) : [...f.interests, i] }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.email || !form.first_name) { toast.error("Completa nombre y correo"); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/subscribers", form);
      toast.success(data.message || "¡Suscrito!");
      setForm({ first_name: "", last_name: "", email: "", interests: [] });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  if (variant === "footer") {
    return (
      <form onSubmit={submit} data-testid="newsletter-footer-form" className="space-y-3">
        <p className="text-white/60 text-sm">Recibe lo mejor de nuestra publicación en tu correo.</p>
        <input data-testid="footer-nl-name" value={form.first_name} onChange={(e) => setForm({ ...form, first_name: e.target.value })}
          placeholder="Nombre" className="w-full bg-white/10 border border-white/20 px-4 py-3 text-sm text-white placeholder:text-white/40 focus:outline-none focus:border-sunset-accent" />
        <input data-testid="footer-nl-email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
          placeholder="Correo electrónico" className="w-full bg-white/10 border border-white/20 px-4 py-3 text-sm text-white placeholder:text-white/40 focus:outline-none focus:border-sunset-accent" />
        <button data-testid="footer-nl-submit" disabled={loading}
          className="w-full bg-sunset-accent text-white kicker py-3 hover:bg-white hover:text-sunset-ink transition-colors disabled:opacity-50">
          {loading ? "Enviando…" : "Suscribirme"}
        </button>
      </form>
    );
  }

  return (
    <section data-testid="newsletter-section" className="bg-sunset-ink text-white">
      <div className="max-w-[1000px] mx-auto px-5 md:px-10 py-24 text-center">
        <p className="kicker text-sunset-accent mb-6">Newsletter</p>
        <h2 className="font-serif text-4xl md:text-6xl tracking-tight mb-5">Mantente al día</h2>
        <p className="text-white/60 max-w-xl mx-auto mb-10">Recibe lo mejor de nuestra publicación directamente en tu correo. Historias, ediciones y contenido exclusivo.</p>
        <form onSubmit={submit} data-testid="newsletter-form" className="max-w-2xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-4">
            <input data-testid="nl-first-name" value={form.first_name} onChange={(e) => setForm({ ...form, first_name: e.target.value })}
              placeholder="Nombre" className="bg-white/10 border border-white/20 px-4 py-3.5 text-sm placeholder:text-white/40 focus:outline-none focus:border-sunset-accent" />
            <input data-testid="nl-last-name" value={form.last_name} onChange={(e) => setForm({ ...form, last_name: e.target.value })}
              placeholder="Apellido" className="bg-white/10 border border-white/20 px-4 py-3.5 text-sm placeholder:text-white/40 focus:outline-none focus:border-sunset-accent" />
            <input data-testid="nl-email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="Correo electrónico" className="bg-white/10 border border-white/20 px-4 py-3.5 text-sm placeholder:text-white/40 focus:outline-none focus:border-sunset-accent" />
          </div>
          <div className="flex flex-wrap justify-center gap-2 mb-8">
            {INTERESTS.map((i) => (
              <button type="button" key={i} onClick={() => toggleInterest(i)}
                className={`kicker text-[10px] px-4 py-2 border transition-colors ${
                  form.interests.includes(i) ? "bg-sunset-accent border-sunset-accent text-white" : "border-white/25 text-white/60 hover:border-white"
                }`}>
                {i}
              </button>
            ))}
          </div>
          <button data-testid="nl-submit" disabled={loading}
            className="bg-white text-sunset-ink kicker px-12 py-4 hover:bg-sunset-accent hover:text-white transition-colors disabled:opacity-50">
            {loading ? "Enviando…" : "Suscribirme"}
          </button>
        </form>
      </div>
    </section>
  );
}
